// src/components/ui/SourcesSection.tsx
import React, { useState } from 'react';
import type { ParsedCitation } from '../../lib/citationParser';

interface Props {
  sources: ParsedCitation[];
}

export function SourcesSection({ sources }: Props) {
  const [expanded, setExpanded] = useState(true);

  if (sources.length === 0) return null;

  return (
    <div className="mt-2 border-t border-gray-100 pt-2">
      <button
        onClick={() => setExpanded(e => !e)}
        className="flex items-center gap-1.5 text-xs text-gray-500 hover:text-gray-700 transition-colors"
      >
        <span>📚</span>
        <span className="font-medium">Sources ({sources.length})</span>
        <span>{expanded ? '▴' : '▾'}</span>
      </button>
      {expanded && (
        <ul className="mt-1.5 space-y-0.5">
          {sources.map((s, i) => (
            <li key={i} className="text-xs">
              <a
                href={s.url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-amber-700 hover:text-amber-900 underline font-mono"
              >
                {s.raw}
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
